module.exports = __webpack_public_path__ + "img/scc-02.bb314180.png";